<template>
    <BModal id="des-modal"
            v-bind:no-close-on-backdrop=true
            dialogClass="modal-dialog-left modal-lg"
            bodyClass="p-3" v-model="modalShow" size="xl">
        <template #header>
            <h2>
               Email
            </h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect
                waves-themed" v-on:click="modalShow = !modalShow">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        <template #title>
            Email
        </template>
        
        <div class="description pl-1 pl-1">
            <QuillEditor
                v-model:content="email"
                contentType="html"
                theme="snow"
                :toolbar="editor_rules"
                placeholder="Введіть опис…"
                class="tender-editor"
            />
        </div>
        
        <template #footer>
            <div  class="main_buttons">
                <BButton :disabled="!canSend" size="lg" class="me-2" variant="primary" @click="sendEmail">
                    Надіслати
                </BButton>
            </div>
        </template>
    </BModal>
</template>
<script>

import { BModal, BButton ,BOverlay} from 'bootstrap-vue-next';
import { QuillEditor } from '@vueup/vue-quill';
export default {
    name: "sendEmail",
    components: {
        BModal,
        BButton,
        BOverlay,
        QuillEditor
    },
    
    emits: ['update:show', 'update:email', 'send'],
    
    data() {
        return {
            editor_rules: [
                ['bold', 'italic', 'underline', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['clean'] // по желанию (ластик)
            ],
            
            is_load : false,
            modalShow : false,
            email: "",
        }
    },
    
    created() {
        EventBus.$on('show_email_send',this.show_email_send);
    },
    
    methods: {
        
        close() {
            this.modalShow = false;
            this.text = '';
            this.title = '';
        },
        
        show_email_send() {
            this.email = '';
            this.modalShow = true;
        },
        
        sendEmail() {
            if(this.canSend) {
                this.$emit('send', this.email)
                this.modalShow = false;
            }
        }
    },
    
    computed: {
        canSend() {
            return this.email.length > 10;
        },
    },
  
}
</script>



<style scoped>

</style>